import "~/misc/common";
import { p } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js";
import { barChartOptions, doughnutChartOptions, lineChartOptions } from "~/misc/charts";

export default class extends Controller {
  connect() {
    var scatter = $('#toJs').data('scatter');
    //p(scatter);
    var ctx = $('#scatter')[0] as HTMLCanvasElement;
    var options = Object.assign({}, lineChartOptions) as any;
    options.scales.x.title.text = scatter.xlabel;
    options.scales.x.title.display = true;
    options.scales.y.title.text = scatter.ylabel;
    options.plugins.tooltip = {
      callbacks: {
        label: function (d: any) {
          return d.raw.label;
        }
      }
    };
    var chart = new Chart(ctx, {
      type: 'scatter',
      data: {
        datasets: scatter.data
      },
      options: options
    });
    chart.update();

    $("#scatter").on('click', function (e) {
      const event = e.originalEvent as MouseEvent;
      const elements = chart.getElementsAtEventForMode(event, 'nearest', {
        intersect: true
      }, false);
      if (elements.length > 0) {
        const point = elements[0];
        const url = scatter.data[point.datasetIndex].data[point.index].url;
        window.open(url, '_blank');
      }
    });

    var doughnut = $('#toJs').data('doughnut');
    var ctx = $('#doughnut')[0] as HTMLCanvasElement;
    var options = Object.assign({}, doughnutChartOptions) as any;
    var doughnutchart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: doughnut.datasets,
        labels: doughnut.labels
      },
      options: options
    });

    var bar = $('#toJs').data('bar');
    //p(bar);
    var ctx = $('#bar')[0] as HTMLCanvasElement;
    var options = Object.assign({}, barChartOptions) as any;
    options.scales.x.stacked = true;
    options.scales.y.stacked = true;
    options.scales.x.title.text = 'Hónap';
    options.scales.x.title.display = true;
    options.scales.y.title.text = bar.ylabel;
    var barchart = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: bar.data,
        labels: bar.labels
      },
      options: options
    });
    barchart.update();
  }
}